import { categories } from '@/mocks/homeData';
import { Link } from 'react-router-dom';

const CategoriesGrid = () => (
  <section id="categorias" className="relative bg-background-100 py-16 md:py-24">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600 mb-3">Navegue pelo Site</p>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            Categorias<br />Populares
          </h2>
        </div>
        <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
          14 categorias com links atualizados. Encontre exatamente o que procura no <strong>Hoobuy Spreadsheet</strong>.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
        {categories.map((cat) => (
          <a
            key={cat.nameEn}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden flex flex-col transition-all duration-300 hover:border-background-300 hover:shadow-sm cursor-pointer"
          >
            {cat.tag && (
              <span className="absolute top-2 right-2 z-10 px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[10px] font-semibold rounded-full">
                {cat.tag}
              </span>
            )}
            <div className="relative w-full aspect-square overflow-hidden">
              <img
                src={cat.imageUrl}
                alt={cat.name + " - Hoobuy Spreadsheet"}
                title={cat.name + " - Hoobuy Spreadsheet em Português"}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
            <div className="p-3 flex flex-col items-center text-center">
              <div className="w-8 h-8 flex items-center justify-center rounded-full bg-background-100 mb-2 group-hover:bg-background-200 transition-colors">
                <i className={`${cat.icon} text-foreground-600 text-sm`}></i>
              </div>
              <h3 className="text-xs font-semibold text-foreground-950 mb-0.5 whitespace-nowrap">{cat.name}</h3>
              <p className="text-[10px] text-foreground-500">{cat.count} itens</p>
            </div>
          </a>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link
          to="/artigo/guia-completo-hoobuy-spreadsheet-2026"
          className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
        >
          Ver guia completo do Hoobuy Spreadsheet
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  </section>
);

export default CategoriesGrid;